import { Actions } from './suiviColisActions';

/**
 * Etat initiale pour le détail d'une réclamation
 */
const initialState = {
    isInfosSuiviColisLoading: false,
    suivisColis: []
};

/**
 * Reducer pour le détail d'une réclamation
 */
const reducer = (state = initialState, action) => {

    switch (action.type) {
        // Informations des infos suivi colis de la réclamation
        case Actions.FETCH_INFOS_SUIVI_COLIS_REQUEST:
            return {
                ...state,
                isInfosSuiviColisLoading: true
            };
        case Actions.FETCH_INFOS_SUIVI_COLIS_SUCCESS:
            return {
                ...state,
                isInfosSuiviColisLoading: false,
                ...state.suivisColis.push(action.infosSuiviColis)
            };
        case Actions.FETCH_INFOS_SUIVI_COLIS_FAILURE:
            return {
                ...state,
                isInfosSuiviColisLoading: false,
                error: action.error
            };

        default:
            return state;
    }
};

export default reducer;